{
	"accept_invite": {
		"description": "Set a password to complete your account activation.",
		"invalid_link_description": "Contact your administrator to request a new invitation.",
		"invalid_link_title": "This invitation link is invalid",
		"submit": "Activate account",
		"success": "Account activated. Sign in with your new password.",
		"title": "Activate your account"
	},
	"back_to_login": "Return to sign in",
	"confirm_password": "Confirm password",
	"cooldown": "Resend in {{seconds}}s",
	"email_placeholder": "Enter your email address",
	"forgot_password": {
		"description": "Enter your account email address and we will send you a password reset link.",
		"email_sent_description": "Check your email and follow the instructions to reset your password.",
		"email_sent_title": "Email sent",
		"resend": "Resend",
		"submit": "Send reset link",
		"title": "Forgot password?"
	},
	"log_in": "Login",
	"login": {
		"forgot_password": "Forgot your password?"
	},
	"reset_password": {
		"description": "Choose a strong password to secure your account",
		"invalid_token": "This password reset link is invalid or has expired.",
		"request_another": "Need a new link? <requestLink>Request another reset email</requestLink>",
		"request_new_link": "Request a new reset link",
		"submit": "Reset password",
		"title": "Set a new password"
	},
	"two_factor": {
		"code_sent": "Verification code sent. Check your inbox.",
		"email_description": "Enter the 6-digit code we sent to your email",
		"methods": {
			"description": "How would you like to verify your identity?",
			"email_description": "Code to your email",
			"email_title": "Email",
			"recovery_description": "One of your backup codes",
			"recovery_title": "Backup codes",
			"title": "Choose a method",
			"totp_description": "Code from your app",
			"totp_title": "Authenticator app"
		},
		"recovery_description": "Enter one of your backup codes to finish signing in",
		"recovery_label": "Backup code",
		"resend": "Resend code",
		"resend_cooldown": "Resend in {{time}}",
		"resend_prompt": "Didn't receive the code?",
		"title": "Verify your identity",
		"totp_description": "Enter the 6-digit code generated by your authenticator app",
		"use_another_method": "Use another method",
		"verify": "Verify"
	},
	"validation": {
		"email_invalid": "Please enter a valid email address.",
		"otp_length": "Code must be 6 digits.",
		"password_invalid": "Please enter a valid password.",
		"passwords_mismatch": "Passwords do not match.",
		"recovery_code_invalid": "Please enter a backup code."
	}
}
